import GroupStrictlyNecessary from './GroupStrictlyNecessary';

export default GroupStrictlyNecessary;
